import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getSettings, subscribeToSettings } from '../firebase/firebase-config';

function Navbar() {
  const [settings, setSettings] = useState({
    schoolName: 'MIS International School',
    logo: '',
    headerBgColor: '#1a3a6b',
    headerTextColor: '#ffffff',
    navLinks: []
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const loadSettings = async () => {
      const data = await getSettings();
      setSettings(data);
    };
    loadSettings();

    const unsubscribe = subscribeToSettings((data) => {
      if (data) setSettings(data);
    });
    
    return () => unsubscribe();
  }, []);

  // Close menu when location changes (navigation occurs)
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const headerBgColor = settings.headerBgColor || '#1a3a6b';
  const headerTextColor = settings.headerTextColor || '#ffffff';
  const schoolName = settings.schoolName || 'MIS International School';
  
  // Default navigation links
  const defaultNavLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Academics', path: '/academics' },
    { name: 'Sports', path: '/sports' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Mandatory Disclosure', path: '/mandatory-disclosure' },
    { name: 'Contact', path: '/contact' }
  ];
  
  const navLinks = settings.navLinks && settings.navLinks.length > 0 ? settings.navLinks : defaultNavLinks;

  // Function to close the mobile menu
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Function to toggle the mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar" style={{ backgroundColor: headerBgColor }}>
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          {settings.logo ? (
            <img src={settings.logo} alt="Logo" className="nav-logo-img" />
          ) : (
            <span className="nav-logo-text" style={{ color: headerTextColor }}>
              {schoolName}
            </span>
          )}
        </Link>
        
        <button 
          className="mobile-menu" 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>
        
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {navLinks.map((link, index) => (
            <li key={index}>
              <Link 
                to={link.path} 
                style={{ color: headerTextColor }}
                className={location.pathname === link.path || location.pathname.startsWith(link.path + '/') ? 'active' : ''}
                onClick={closeMenu}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <style>{`
        .navbar {
          position: sticky;
          top: 0;
          z-index: 1000;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .nav-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 15px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .nav-logo {
          text-decoration: none;
          font-size: 1.2rem;
          font-weight: bold;
          display: flex;
          align-items: center;
        }
        
        .nav-logo-img {
          height: 45px;
          width: auto;
          object-fit: contain;
        }
        
        .nav-logo-text {
          font-weight: 700;
          font-size: 18px;
        }
        
        .nav-menu {
          display: flex;
          list-style: none;
          gap: 30px;
          margin: 0;
          padding: 0;
        }
        
        .nav-menu li a {
          text-decoration: none;
          font-weight: 500;
          transition: all 0.2s ease;
          padding-bottom: 5px;
          display: inline-block;
        }
        
        .nav-menu li a:hover {
          opacity: 0.8;
          transform: translateY(-1px);
        }
        
        .nav-menu li a.active {
          font-weight: 700;
          border-bottom: 2px solid #f59e0b;
        }
        
        .mobile-menu {
          display: none;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: ${headerTextColor};
          transition: transform 0.2s ease;
        }
        
        .mobile-menu:hover {
          transform: scale(1.1);
        }
        
        @media (max-width: 768px) {
          .mobile-menu {
            display: block;
          }
          
          .nav-menu {
            display: none;
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background: ${headerBgColor};
            flex-direction: column;
            padding: 20px;
            text-align: center;
            gap: 15px;
            z-index: 999;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
          }
          
          .nav-menu.active {
            display: flex;
          }
          
          .nav-menu li a {
            padding: 10px;
            display: block;
            width: 100%;
          }
          
          .nav-menu li a.active {
            border-bottom: none;
            background: rgba(255,255,255,0.15);
            padding: 10px;
            border-radius: 8px;
          }
          
          .nav-menu li a:hover {
            background: rgba(255,255,255,0.1);
            border-radius: 8px;
            transform: translateY(0);
          }
        }
      `}</style>
    </nav>
  );
}

export default Navbar;